// extracted by mini-css-extract-plugin
export var button = "_am-7";
export var buttonRow = "_am-6";
export var fadeIn = "_am-1";
export var gradient = "_am-0";
export var panel = "_am-2";
export var panelIn = "_am-3";
export var subtitle = "_am-5";
export var title = "_am-4";